import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import {
  CheckBox,
  InputField,
  Upload,
  Select,
  MultiSelect,
  FormGroup
} from '../../../components/form';
import {
  getUserAction,
  createUserAction,
  updateUserAction,
  checkEmailExistAction
} from '../../../modules/users/Actions';
import {
  usersIsLoadingSelector,
  userByIdSelector,
  emailExistSelector
} from '../../../modules/users/Selectors';

import { newErrorNotificationAction } from '../../../modules/notifications/Actions';

import {
  authUserIdSelector,
  authCurrentUserSelector
} from '../../../modules/auth/Selectors';

import countriesList from './countriesList';
import schema from './usersSchema';
import Spearator from '../../../components/form/Misc/Separator';
import { updateCurrnetUserAction } from '../../../modules/auth/Actions';
import CitiesList from './CitiesList';
import getLangData from '../../../utils/getLangData';

const options = [
  { value: '0', label: 'Admin' },
  { value: '4', label: 'Customer' },
  { value: '3', label: 'Artisan' },
  { value: '5', label: 'Supplier' },
  { value: '7', label: 'Applicant' },
];

const UpdateUserForm = props => {
  const {
    user,
    userId,
    getUser,
    isLoading,
    updateUser,
    createUser,
    errorAction,
    emailExists,
    checkEmail
  } = props;

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
  }, [getUser, userId]);

  return (
    <Formik
      validationSchema={schema(false)}
      enableReinitialize
      initialValues={user ? { ...user } : schema().cast()}
      onSubmit={async (values, { setSubmitting }) => {
        if (emailExists) {
          errorAction('Please Check Your Email');
          return;
        }
        const {
          changedPassword,
          password,
          email,
          ...valuesWithoutPasswordOrEmail
        } = values;
        let data = { ...valuesWithoutPasswordOrEmail };
        if (
          values.changedPassword &&
          values.changedPassword === values.passwordConfirmation &&
          values.email !== user.email
        ) {
          data = {
            password: changedPassword,
            email,
            ...valuesWithoutPasswordOrEmail
          };
        } else if (values.email !== user.email) {
          data = { email, ...valuesWithoutPasswordOrEmail };
        } else if (
          values.changedPassword &&
          values.changedPassword === values.passwordConfirmation
        ) {
          data = { password: changedPassword, ...valuesWithoutPasswordOrEmail };
        }
        console.log(data);

        if (values.changedPassword) {
          if (values.changedPassword !== values.passwordConfirmation) {
            errorAction('Password Does Not Match');
          } else if (values.changedPassword === values.passwordConfirmation) {
            // data = { password: changedPassword, ...data };
            updateUser(userId, data);
          }
        } else if (user.email !== values.email) {
          // data = { email, ...data };
          updateUser(userId, data);
        } else {
          updateUser(userId, data);
        }
      }}
    >
      {({ handleSubmit, values, setFieldValue, errors, isSubmitting }) => (
        <FormGroup
          disabled={isSubmitting}
          isLoading={isLoading}
          handleSubmit={handleSubmit}
          heading={`${getLangData().buttons.update} [${user.firstName} ${
            user.lastName
          }]`}
          errors={errors}
        >
          <InputField label={getLangData().fields.first_name} name='firstName' />
          <InputField label={getLangData().fields.last_name} name={'lastName'} />
          <Upload
            data={{ userID: userId }}
            name='picture'
            label={getLangData().fields.picture}
            S3Bucket='warshatna-users'
            // API="customer/customer-category-image-signedurl/"
            API='users/user-profile-image-signedurl'
          />
          <InputField
            label={getLangData().fields.email}
            name='email'
            emailError={emailExists}
            onBlur={() => {
              checkEmail(values.email);
              if (user.email !== values.email) {
                checkEmail(values.email);
              }
            }}
          />

          {/* <Select
            label='Country'
            name='country'
            value={countriesList.filter(
              (object) => values.country.indexOf(object.value) > -1
            )}
            options={countriesList}
            onChange={(value) => {
              setFieldValue("country", value.value);
            }}
          /> */}
          <Select label={getLangData().fields.city} name='city' options={CitiesList} />
          <InputField label={getLangData().fields.address} name='address' />
          <InputField label={getLangData().fields.phone} name='phone' />
          {/* <InputField label="Province" name="province" /> */}
          <InputField label={getLangData().fields.zip_code} name='zipCode' />
          <Spearator />
          <InputField label={getLangData().fields.password} name='changedPassword' />
          <InputField label={getLangData().fields.confirm_Password} name='passwordConfirmation' />
          {/* <MultiSelect label='User Type' name='userType' options={options} /> */}
          {/* <CheckBox
            label='Email Verified'
            name='emailVerified'
            subLabel='Verify the Email'
            tip='Email is Not Verified'
          /> */}
          {/* <CheckBox
            label='status'
            name='status'
            subLabel='Activate User'
            tip='User is Deactivated'
          /> */}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  // const userId = props.match.params.id;
  return {
    userId: authUserIdSelector(state),
    isLoading: usersIsLoadingSelector(state),
    user: authCurrentUserSelector(state),

    emailExists: emailExistSelector(state)
  };
};

const mapDispatchToProps = {
  getUser: getUserAction,
  createUser: createUserAction,
  updateUser: updateCurrnetUserAction,
  errorAction: newErrorNotificationAction,
  checkEmail: checkEmailExistAction
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserForm);
